import { apiClient } from "@/services/HttpService";

export function fetchLogList(searchParam) {
  return apiClient.get(`/operate-logs?keyword=${searchParam.keyword}&pageNum=${searchParam.pageNum}&pageSize=${searchParam.pageSize}`);
}